/*
 * Redirect to checkout when the product has been added to cart.
 * There is no "/checkout" variable available in `window.routes` or the routes liquid object.
 */
subscribe(PUB_SUB_EVENTS.cartUpdate, (_) => (window.location.href = '/checkout'));
